export {default} from './PendingTipCard';
